// Consent-aware analytics - must load before any tracking scripts
import './js/analytics/consent-datalayer-manager.js';
import './dayjs.js';
import './js/sentry.js';

import * as Turbo from '@hotwired/turbo';
import { registerSvelteControllerComponents } from '@symfony/ux-svelte';

import 'core-js/actual/structured-clone';
import './css/main.scss';

// start the Stimulus application
import { startStimulusApp } from '@symfony/reprise/stimulus';

import CurrencyStoreController from './svelte/saga/controllers/CurrencyStoreController.svelte';
// Import Svelte components individually
import HomeSearchController from './svelte/saga/controllers/HomeSearchController.svelte';
import SearchBarController from './svelte/saga/controllers/SearchBarController.svelte';
import SearchInitStoreController from './svelte/saga/controllers/SearchInitStoreController.svelte';

Turbo.session.drive = false;

// Registers Stimulus controllers from controllers.json and in the controllers/ directory
startStimulusApp();

// Create a custom context function that behaves like import.meta.webpackContext for registerSvelteControllerComponents to work
const customContext = function (key) {
    return customContext._components[key];
};

customContext._components = {
    './HomeSearchController.svelte': { default: HomeSearchController },
    './SearchBarController.svelte': { default: SearchBarController },
    './SearchInitStoreController.svelte': {
        default: SearchInitStoreController,
    },
    './CurrencyStoreController.svelte': {
        default: CurrencyStoreController,
    },
};

customContext.keys = function () {
    return Object.keys(this._components);
};

// Register our Svelte components
registerSvelteControllerComponents(customContext);
